import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import {
	versionsRequiredScopes as fixVersionsRequiredScopesBase,
	type VersionsPublicSetValue as FixVersionsPublicSetValue,
} from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/versions.tsx';
import { getValueLookupValuesDiff } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-value-lookup-values-diff/index.tsx';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';
import { multiValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/multi-value-lookup/index.tsx';

type PublicValue = {
	id: string;
	name: string;
};

type InternalValue = {
	label: string;
	value: string;
};

type FixVersionsInternalValue = InternalValue[];

type FixVersionsPublicGetValue = PublicValue[];

type FixVersionsLookupValue = {
	id: string;
	name: string;
};

export const fixVersionsSetValueValidator = (value: unknown): value is FixVersionsPublicSetValue =>
	Array.isArray(value) && value.every(isNotEmptyString);

export const transformVersionsSetValue = (
	values: FixVersionsPublicSetValue,
	lookupValues?: FixVersionsLookupValue[],
): FixVersionsInternalValue => {
	if (!values.length) {
		return [];
	}

	const filteredLookupValues = multiValueLookup<FixVersionsLookupValue>(values, lookupValues, 'id');

	if (values.length !== filteredLookupValues.length) {
		const notFoundValues = getValueLookupValuesDiff(values, filteredLookupValues, 'id');

		throw new FieldValueLookupError(notFoundValues.join());
	}

	return filteredLookupValues.map(({ name, id }) => ({ label: name, value: id }));
};

export const transformVersionsGetValue = (
	internalValue: InternalValue[],
): FixVersionsPublicGetValue => {
	if (!internalValue) return [];

	return internalValue.map(({ value, label }) => ({
		id: value,
		name: label,
	}));
};

export const versionsRequiredScopes = {
	...fixVersionsRequiredScopesBase,
	granular: [...fixVersionsRequiredScopesBase.granular, 'write:field.default-value:jira'],
};
